import { ref } from "vue";
const MAX_NOTIFICATIONS = 5;
const notifications = ref([]);
const nextId = ref(0);
const statusMapper = ref(null);
function setStatusMapper(mappedStatus) {
  const mapper = (customStatus) => {
    return mappedStatus[customStatus];
  };
  statusMapper.value = mapper;
}
function getNotificationStatus(status) {
  const validStatuses = ["DANGER", "WARNING", "SUCCESS", "NEUTRAL", "INFO", "DARK"];
  const mappedStatus = statusMapper.value?.(status);
  const finalStatus = mappedStatus || (validStatuses.includes(status) ? status : "NEUTRAL");
  return finalStatus;
}
function showNotification(options) {
  const status = getNotificationStatus(options.status || "");
  const newNotification = {
    id: nextId.value++,
    type: options.type || "toast",
    status,
    text: options.text || "",
    position: options.position,
    icon: options.icon,
    additionalContent: options.additionalContent,
    persist: options.persist,
    showCloseIcon: options.showCloseIcon,
    rounded: options.rounded,
    onClick: options.onClick,
    onClose: options.onClose
  };
  notifications.value.unshift(newNotification);
  if (notifications.value.length > MAX_NOTIFICATIONS) {
    notifications.value.pop();
  }
  return newNotification.id;
}
function dismissNotification(id) {
  const index = notifications.value.findIndex((n) => n.id === id);
  if (index !== -1) {
    notifications.value.splice(index, 1);
  }
}
function useNotificationStore() {
  return {
    notifications,
    showNotification,
    setStatusMapper,
    getNotificationStatus,
    dismissNotification
  };
}
export {
  useNotificationStore
};
//# sourceMappingURL=notification.store.js.map
